<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <v-row no-gutters class="mb-5">
      <v-col cols="12" md="10">
        <h2>Archyvo naikinimas</h2>
      </v-col>
      <v-col cols="12" md="2" class="text-right"> </v-col>
    </v-row>

    <v-sheet class="d-flex justify-start" color="transparent">
      <v-card flat style="width: 200px;" color="transparent" class="mr-5">
        <v-card>
          <v-list dense>
            <v-list-item-group v-model="selectedTab" color="primary" mandatory>
              <v-list-item
                v-for="(item, i) in filteredTabItems"
                :key="i"
                @click="gotoTab(item)"
              >
                <v-list-item-content>
                  <v-list-item-title
                    :class="tabClass(item)"
                    v-text="item.title"
                  ></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-card>
      <v-card v-if="activeTab >= 0" width="100%" min-width="800px">
        <component
          :is="tabItems[activeRoute].component"
          :readonly-form="tabItems[activeRoute].readonly"
          class="tabComponent"
        ></component>
      </v-card>
    </v-sheet>
  </v-container>
</template>

<script>
import { authRoute } from './../../router/routeRole'
import unsavedDataRoute from '../../mixins/unsavedDataRoute'

import NaikinimasFormavimas from './NaikinimasFormavimas'
import NaikinimasAktas from './NaikinimasAktas'
import NaikinimasArchyvaras from './NaikinimasArchyvaras'

export default {
  name: 'NaikinimasTab',
  mixins: [unsavedDataRoute],
  data() {
    return {
      selectedTab: null,
      pageloading: false,
      tabInfo: {
        obj_dokumento_numeris: null,
      },
    }
  },
  computed: {
    routeItems() {
      return {
        naikinimasFormavimas: {
          title: 'Naikinimo akto formavimas',
          route: 'naikinimasFormavimas',
          component: NaikinimasFormavimas,
          readonly: false,
        },
        naikinimasAktas: {
          title: 'Naikinimas pagal aktą',
          route: 'naikinimasAktas',
          component: NaikinimasAktas,
          readonly: false,
        },
        naikinimasArchyvaras: {
          title: 'Naikinimo aktas archyvarui',
          route: 'naikinimasArchyvaras',
          component: NaikinimasArchyvaras,
          readonly: false,
        },
      }
    },
    tabItems() {
      return Object.entries(this.routeItems).map(([key, item]) => {
        return item
      })
    },
    filteredTabItems() {
      return this.tabItems.filter(item => {
        return !item.hide && authRoute(item.route)
      })
    },
    activeTab: {
      set(value) {
        this.selectedTab = value
      },
      get() {
        return this.filteredTabItems.findIndex(function(item, index) {
          return this.$route.matched.find(element => {
            if (item.route === element.name) {
              return true
            }
          })
        }, this)
      },
    },
    activeRoute() {
      return this.tabItems.findIndex(function(item, index) {
        if (this.isActiveRoute(item.route)) {
          return true
        }
      }, this)
    },
  },
  created() {
    this.selectedTab = this.activeTab
  },
  methods: {
    gotoTab(item) {
      if (this.$route.name !== item.route) {
        this.$router.push({
          name: item.route,
        })
      }
    },
    tabClass(item) {
      return 'tabItem ' + (item.readonly ? 'readonly' : '')
    },
    isActiveRoute(routeName) {
      return (
        this.$route.matched.filter(item => item.name === routeName).length > 0
      )
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/elementsTheme.scss';
.tabItem {
  &.readonly {
    color: $secondary;
  }
}
.tabComponent {
  margin: 0 auto 0 0;
}
</style>
